import React, { useState, useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import withAuth from "lib/hoc/withAuth";
import TableLayout from "components/Forms/TableLayout/TableLayout";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { GetUserBusinessUnits } from "app/features/userSlice";
import Table from "ui/organisms/Table";
import Filters from "./components/Filters";
import { fileColumns } from "./components/columns";
import { LocalStorageHelper } from "lib/helpers/localStorageHelper";
import { historyFileGridMapper } from "lib/helpers/reportsHelper";
import { getSumaryExcelFilesLog, selectBusiness } from "app/features/personSlice";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Chip from "ui/molecules/Chip";

const FileHistory = () => {
  const dispatch = useAppDispatch();
  const { accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { userBusinesses } = useAppSelector((state) => state.user) ?? [];
  const { files, fileLoading, businessSelected } = useAppSelector((state) => state.person);
  const userLogged = LocalStorageHelper.getItem("user-logged");
  const [business, setBusiness] = useState<string>(businessSelected);

  const onSelectBusiness = (event: any) => {
    const codeUp = event.target.value;
    setBusiness(codeUp);
    dispatch(selectBusiness(codeUp));
    dispatch(getSumaryExcelFilesLog(codeUp));
  };

  useEffect(() => {
    if (isAuthenticated) {
      const userLogged = accounts[0]?.username;
      dispatch(GetUserBusinessUnits(userLogged));
    }
  }, [userLogged]);

  return (
    <TableLayout maxWidthCard={1600} maxWidthContainer='xl' title='Historial de Archivos'>
      <Chip
        link='/survey/send'
        label='Volver'
        color='primary'
        backgroundColor='#4e5559'
        hoverTextColor='white'
        icon={<ArrowBackIcon />}
        hoverBackgroundColor='#727b81'
      />
      <Filters business={business} handleSelect={onSelectBusiness} userBusinesses={userBusinesses} />
      <Table
        isLoading={fileLoading}
        dataGridColumns={fileColumns}
        rows={historyFileGridMapper(files)}
        fileName='file-history'
      />
    </TableLayout>
  );
};

export default withAuth(FileHistory);
